
<script lang="ts" setup>
import { reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
} from "./EditComponentStatic";
const emitFn = defineEmits<CommonEditControlEmits>();

const props = defineProps<EditControlProps>();
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
var uiData = reactive(ui);
</script>
<template>
  <label>{{ uiData.description }}</label>
  <p>{{ uiData.data }}</p>
</template>
<style scoped>
</style>
